import { gql } from '@apollo/client';
import type { SerializedInventoryMeter } from '@enmon/commons/lib/tools';

export const GET_INVENTORY_METER = gql`
  query getInventoryMeter($id: ID) {
    inventoryMeter(id: $id) {
      data {
        id
        attributes {
          meter_mount_type
        }
      }
    }
  }
`;

export interface InventoryMeterData {
  inventoryMeter: {
    data: Pick<SerializedInventoryMeter, 'id' | 'meter_mount_type'>;
  };
}
